import { Dropdown, Menu } from 'antd';
import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const DropdownCont = styled(Dropdown)`
  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.mikro};
    color: ${theme.colors.neutral.primary[100]};
  `}

  &:hover {
    ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[100]};
    `}
  }
`;

export const MenuCont = styled(Menu)`
  ${({ theme }: IThemeProvider) => `
    border: 1px solid ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro};
    color: ${theme.colors.neutral.primary[100]};
    padding: 0;
  `}

  .ant-dropdown-menu-item {
    &:first-child {
      ${({ theme }: IThemeProvider) => `
      border-radius: ${theme.layout.spacing.mikro} ${theme.layout.spacing.mikro} 0 0;
    `}
    }
    &:last-child {
      ${({ theme }: IThemeProvider) => `
      border-radius: 0 0 ${theme.layout.spacing.mikro} ${theme.layout.spacing.mikro};
    `}
    }
  }

  .ant-dropdown-menu-item:hover {
    ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.neutral.primary[0]};
      color: ${theme.colors.neutral.primary[100]};
    `}
  }

  .ant-dropdown-menu-item-selected {
    ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
      color: ${theme.colors.neutral.primary[100]};
    `}
  }
`;
